/* eslint-disable react/sort-comp */
import jsonpack from "jsonpack";
import sweetalert from "sweetalert";
import { Divider, Empty, Tabs } from "antd";
import { toast } from "extensions/toast";
import { createRef, Component } from "react";
import { connect } from "react-redux";
import { get, isPlainObject } from "lodash-es";

import { pazienHistory } from "common/components/pazienHistory";
import { Qualifiers } from "common/components/queryBuilder/qualifiers";
import { SCHEDULE_AUTOMATIC_DOWNLOAD } from "common/reducers/downloads";
import { ToastWithActions } from "common/components/toastActions/toastActions";
import { ErrorView } from "common/components/error";

import {
    ErrorFetchingAdminReport,
    ErrorMissingRequestedItem,
    ErrorMissingReportSchema
} from "common/helpers/errors";

import {
    FETCH_REPORT_FORM,
    REPORT_FETCH,
    PREFETCH_ACTION_DIALOG,
    SUBMIT_ACTION,
    SUBMIT_REPORT_FORM,
    REPORT_NEW_ITEM_WITH_CHILDREN,
    EXPORT_REPORT,
    UPDATE_ITEM_ID,
    updateURL
} from "common/actions/reports";

import { faBell } from "@fortawesome/pro-light-svg-icons";

import { ActionDialog } from "./actionDialog";
import { ReportFormRedux } from "./reportForm";
import { ReportGrid } from "./reportGrid";
import { ReportHeader } from "./reportHeader";

import { ReportStatistic } from "./components/reportStatistic";

const mapStateToProps = (state, ownProps) => {
    const base = {
        isLoadingAll: state.reports.all_reports.loading,
        tempSelectedItems: state.reports.options.selectedChildren,
        tempParentReportId: state.reports.options.id,
        tempChildReportId: state.reports.options.selectedChildReportId,
        globalFilter: state.reports.options.filter,
        globalItemId: state.reports.options.itemId,
        globalLastItemId: state.reports.options.lastItemId,
        filterBar: state.reports.options.filterBar
    };
    let meta;
    if (typeof ownProps.parentSelectedAction === "undefined" || ownProps.parentSelectedAction?.format !== "form_action") {
        meta = ownProps.meta || state.reports.all_reports.data?.find(({ _id, canonical_name }) => _id === ownProps.id || canonical_name === ownProps.id);
    }
    
    return {
        ...base,
        // Leaving hasCheckbox and showCheckbox
        // for now in case some weird edge case shows up
        // but as cleanup this should probably get
        // collapsed into one flag.
        hasCheckbox: ownProps.showCheckbox,
        hasRadio: ownProps.showRadio,
        meta
    };
};
const mapDispatchToProps = {
    PREFETCH_ACTION_DIALOG,
    EXPORT_REPORT,
    SUBMIT_ACTION,
    REPORT_NEW_ITEM_WITH_CHILDREN,
    UPDATE_ITEM_ID,
    SCHEDULE_AUTOMATIC_DOWNLOAD
};

class ReportViewRedux extends Component {
    #fetchPromise = null;

    #fetchChildrenPromises = {};

    constructor(props) {
        super(props);
        this.reportGridRef = createRef();
        this.state = {
            showActionsModal: false,
            selectedRows: [],
            displayChildReport: false,
            selectedAction: null,
            walk: this.props.isMainReport ? this.props.walk || [] : [],
            filter: this.props.isMainReport ? this.props.globalFilter || "{}" : "{}",
            temp_filter: this.props.isMainReport ? this.props.globalFilter || "{}" : "{}",
            qualifiers: this.props.isMainReport ? props.filterBar : "",
            loading: true,
            loaded: false,
            page: 1,
            itemId: this.props.isMainReport ? this.props.globalItemId || null : null,
            lastItemId: this.props.isMainReport ? this.props.globalLastItemId || null : null,
            child_reports: null,
            error: {
                has_error: false,
                status: null,
                statusText: null
            }
        };
        if (this.state.itemId) {
            this.state.displayChildReport = true;
        }
        if (this.props.report) {
            this.state.loading = false;
            this.state.loaded = true;
            this.state.report = this.props.report;
        }
    }

    componentDidMount() {
        if (this.props.parentSelectedAction === null || ["form_action", "combo_action"].includes(this.props.parentSelectedAction?.format)) {
        // this might be a good basis for beginning to consider
        // what can be completely split out in the case of action reports
        // so that they get their own component to reduce complexity here.
            PREFETCH_ACTION_DIALOG({
                id: this.props.id,
                page: this.state.page,
                parentReportId: this.props.parentId,
                action: this.props.parentSelectedAction.action_key,
                parentReportItemIds: this.props.parentSelectedRows,
                queryParams: {
                    filters: this.state.filter,
                    ...this.props.queryParams
                }
            }).then((data) => {
                this.setState({
                    form_data: data.form_data,
                    report: data.grid_data,
                    meta: {
                        ...this.props.meta,
                        schema: data.form_schema,
                        uiSchema: data.form_ui_schema,
                        has_comments: false
                    },
                    loading: false,
                    loaded: true
                });
            });
        } else if (!this.props.report) {
            this.fetchData();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.id !== prevProps.id
            || this.state.page !== prevState.page
            || this.state.filter !== prevState.filter
            || (this.state.itemId !== prevState.itemId && !this.state.loaded)) {
            this.fetchData();
            return;
        }

        if (this.state.itemId && this.props.meta?.childReportId && !this.state.childReportLoaded && !this.state.childReportLoading) {
            this.fetchData();
        }
    }

    componentWillUnmount() {
        if (this.#fetchPromise) {
            this.#fetchPromise.cancel();
        }
    }
    
    handleAction = ({
        actionKey,
        parentReportId,
        childReportId,
        parentReportItemId = null,
        selectedChildItemIdList = null,
        formData = null,
        filter = null
    } = {}) => {
        const actionArgs = {
            childReportId,
            parentReportId,
            selectedChildItemIdList,
            action: actionKey,
            filter
        };
        if (parentReportItemId !== null) actionArgs.parentReportItemId = Array.isArray(parentReportItemId) ? parentReportItemId[0] : parentReportItemId;
        if (selectedChildItemIdList !== null) actionArgs.selectedChildItemIdList = selectedChildItemIdList;
        if (filter !== null) actionArgs.filter = filter;
        if (formData !== null) actionArgs.formData = formData;
        
        return this.props.SUBMIT_ACTION(actionArgs).then(() => {
            this.fetchData();
            let toastMessage;
            const stateToSet = { selectedAction: null };
            if (actionKey === "assign" && selectedChildItemIdList === null) {
                toastMessage = `${this.state.selectedAction.action_display_name} has completed.`;
            } else if (formData !== null) {
                toastMessage = `${this.state.selectedAction.action_display_name} has completed.`;
                stateToSet.selectedRows = [];
                stateToSet.dialog = null;
            } else {
                toastMessage = `Successfully completed action for ${this.state.selectedRows.length} row${this.state.selectedRows.length > 1 ? "s" : ""}.`;
                stateToSet.selectedRows = [];
            }
            toast.success(toastMessage);
            this.setState(stateToSet);
        });
    };
    
    handleSimpleAction(index) {
        const action = this.props.meta.report_action_configs[index];
        this.handleAction({
            childReportId: this.props.id,
            parentReportId: action.admin_report_ref,
            selectedChildItemIdList: this.state.selectedRows,
            actionKey: action.action_key,
            filter: this.state.filter
        });
    }
    
    setFilter(newFilter = "{}") {
        this.setState({ temp_filter: newFilter });
    }
    
    getColumnNames = () => {
        if (this.state.frankenResult) {
            return Object.keys(this.state.frankenResult);
        }
    };
    
    onApplyFilter = (e) => {
        e.preventDefault();
        this.applyFilter();
    };
    
    onFilterBarUpdate = (qualifiers) => {
        this.setState({ qualifiers }, () => {
            if (qualifiers === "") this.applyFilter();
        });
    };
    
    onClearFilter = (e) => {
        e.preventDefault();
        this.setState({
            temp_filter: "{}",
            qualifiers: ""
        }, this.applyFilter);
    };
    
    onFilterChange = (event) => {
        this.setFilter(event.target.value || "{}");
    };
    
    onKeyPressSearch = (event) => {
        if (event.key === "Enter") {
            this.applySearchFilterFromEvent(event);
            this.applyFilter();
        }
    };
    
    onSearchChange = (event) => {
        this.applySearchFilterFromEvent(event);
    };
    
    onRefreshFilter = (e) => {
        e.preventDefault();
        this.fetchData();
    };
    
    handlePageClick = (selected) => {
        this.setState({
            page: selected
        }, () => {
            if (this.props.isMainReport) {
                updateURL({
                    filter: this.state.temp_filter,
                    filterBar: this.state.qualifiers,
                    page: selected,
                    walk: this.state.walk,
                    itemId: this.state.itemId,
                    id: this.props.id
                });
            }
        });
    };
    
    exportHandler = (exportValues) => {
        this.props.EXPORT_REPORT({
            filename: exportValues.filename,
            canonical_name: this.props.id,
            filters: this.state.filter,
            filterBar: encodeURIComponent(this.state.qualifiers),
            headers: exportValues.headers,
            backref: this.props.queryParams?.backref,
            grid_display_overrides: this.props.meta?.grid_display_overrides
        }).then((data) => {
            if (exportValues.shouldStartDownloadAutomatically) {
                this.props.SCHEDULE_AUTOMATIC_DOWNLOAD(data.job_ref);
            }
            toast.success(<ToastWithActions
                message="Your file will appear in the notifications panel when ready for download."
                wrapInToastIconDiv
                iconProps={{
                    icon: faBell
                }}
                actions={[{
                    buttonText: "Open downloads",
                    action: () => pazienHistory.navigate("downloads/", { trigger: true, replace: true })
                }]}
            />);
        }).catch((error) => {
            toast.error("Unable to create an export job");
        });
    };

    eventHandler = ({ type, data }) => {
        if (type === "CHECKBOX_CHANGE") {
            this.setState({
                selectedRows: data
            });
        }
    };

    createNewHandler = () => {
        // calling with new creates a new item.
        this.reportDisplayArray({ itemId: "new" });
    };

    showAssignedItemsHandler = () => {
        if (this.state.itemId === "new") {
            toast.warning("Please save the report item first");
            return;
        }

        this.setState((prevState) => ({
            displayChildReport: !prevState.displayChildReport
        }));
    };
    
    onActionSelectedHandler = (index) => {
        const action = this.props.meta.report_action_configs[index];
        this.setState({ selectedAction: action }, () => {
            if (action.format !== "simple_action") {
                this.setState({
                    showActionsModal: true
                });
            } else if (!action.validate_action) {
                this.handleSimpleAction(index);
            } else {
                let text;
                const selectedRowsLength = this.state.selectedRows?.length;
                const title = `Are you sure you want to ${action.action_description.toLowerCase()} ${selectedRowsLength !== 0 ? `for ${selectedRowsLength} row${selectedRowsLength > 1 ? "s" : ""}` : ""}?`;
                if (selectedRowsLength === 0) {
                    text = "";
                } else {
                    text = selectedRowsLength < 20 ? this.state.selectedRows.join("\n") : `${this.state.selectedRows.slice(0, 20).join("\n")}\n...`;
                }
              
                sweetalert({
                    title,
                    text,
                    icon: "warning",
                    buttons: {
                        confirm: {
                            text: `${action.action_display_name}`
                        },
                        cancel: {
                            visible: true
                        }
                    }
                }).then((confirmed) => {
                    if (confirmed) {
                        this.handleSimpleAction(index);
                    } else {
                        this.setState({ selectedAction: null });
                    }
                });
            }
        });
    };
    
    handleCancelForm = (qualifiers) => (e) => {
        e.preventDefault();
      
        const parsedParams = new Qualifiers({ value: qualifiers }).value.reduce((memo, { category, values }) => ({
            ...memo,
            [category]: category === "walk" ? jsonpack.unpack(values[0].value) : values[0].value
        }), {});
        let itemId = parsedParams.itemId;
        if (!itemId || itemId === "null" || itemId === "new") {
            itemId = null;
        }
        this.setState((prevState) => {
            const base = {
                id: parsedParams ? parsedParams.id || this.props.id : this.props.id,
                walk: parsedParams ? parsedParams.walk || [] : [],
                filter: prevState.filter,
                filterBar: prevState.qualifiers,
                page: prevState.page,
                child_reports: null,
                displayChildReport: false,
                selectedAction: null
                
            };
            if (this.props.isMainReport) {
                this.props.UPDATE_ITEM_ID(itemId);
                updateURL(base);
            }
            
            return Object.assign(base, {
                itemId,
                lastItemId: prevState.itemId,
                selectedChildReportId: null,
                selectedChildren: []
            });
        });
    };
    
    handleSubmitForm = ({ formData }) => {
        const isNew = this.state.itemId === "new";
        SUBMIT_REPORT_FORM(formData, { id: this.props.id, itemId: this.state.itemId }).then((data) => {
            this.setState((prevState, props) => {
                const base = {
                    itemId: isNew ? data._id : prevState.itemId,
                    walk: prevState.walk || [],
                    id: props.id,
                    filter: prevState.filter,
                    filterBar: prevState.qualifiers,
                    page: prevState.page
                };
                if (isNew) {
                    updateURL(base);
                }
                return base;
            });
            this.fetchData();
            toast.success("Report has been saved");
            if (this.props.tempSelectedItems.length) {
                this.handleAction({
                    childReportId: this.props.tempChildReportId,
                    parentReportId: this.props.tempParentReportId,
                    parentReportItemId: this.state.itemId,
                    selectedChildItemIdList: this.props.tempSelectedItems,
                    actionKey: "assign"
                });
            }
        }, (error) => {
            toast.error(error.response?.parsed?.description || "There was an error saving your report item");
        });
    };
    
    reportDisplayArray = ({ itemId = void 0, index, column = void 0 }) => {
        let walk = [];
        if (itemId) {
            this.setState((prevState) => {
                if (!prevState.displayChildReport) {
                    return { displayChildReport: true, qualifiers: "", filterBar: "" };
                }
            });
        }
        if (column) {
            if ((itemId && this.state.walk.length === 0) || !Number.isFinite(index)) {
                walk = [...this.state.walk, column];
            } else {
                walk = [...this.state.walk, index, column];
            }
        }
        this.setState((prevState, props) => {
            const base = {
                itemId: itemId || prevState.itemId,
                lastItemId: prevState.itemId,
                walk
            };
            if (this.props.isMainReport) {
                this.props.UPDATE_ITEM_ID(itemId);
                updateURL(Object.assign(base, {
                    filter: prevState.filter,
                    filterBar: prevState.qualifiers,
                    id: props.id,
                    page: prevState.page
                }));
            }
            return base;
        });
        this.fetchData();
    };
    
    handleFetchPromise = (fetchPromise) => {
        if (this.#fetchPromise) {
            this.#fetchPromise.cancel();
        }
        this.#fetchPromise = fetchPromise;
        this.runFetchPromise();
    };
    
    runFetchPromise = () => {
        this.setState({
            loading: true,
            loaded: false,
            error: {
                has_error: false,
                status: null,
                statusText: null
            }
        });

        this.#fetchPromise.then((data) => {
            data = data?.grid_data || data;
            const frankenResult = this.getFrankenResult(data.results);
            this.setState({
                loading: false,
                loaded: true,
                report: data,
                frankenResult
            });
        }, (error) => {
            this.setState({
                loading: false,
                loaded: true,
                error: {
                    has_error: true,
                    status: error.response?.status,
                    statusText: error.response?.statusText
                }
            });
            toast.error(error.response?.parsed?.description || "There was an error fetching a report");
        });
    };
    
    fetchReportForm = () => {
        this.setState({ childReportLoading: true });
        return FETCH_REPORT_FORM({ id: this.props.id, itemId: this.state.itemId });
    };
    
    getCacheFunctions = () => ({
        cacheReportValues: this.props.cacheReportValues,
        getCachedReportValues: this.props.getCachedReportValues
    });
    
    getGenericReportGridProps = () => ({
        meta: this.state.meta || this.props.meta,
        itemId: this.state.itemId,
        className: "report-grid",
        eventHandler: this.eventHandler,
        error: this.state.error,
        loading: this.state.loading,
        reportDisplayArray: this.reportDisplayArray,
        handlePageClick: this.handlePageClick
    });
    
    setActiveTab = (activeTab) => {
        this.setState({ activeTab });
    };

    getChildReportEntry = (canonicalName, data, childReports) => ({ ...childReports, [canonicalName]: Object.assign(data, { admin_report_name: this.props.findReport(canonicalName)?.admin_report_name }) });
    
    /* frankenResult is an all-destroying abomination containing
    all possible columns and a representative value
    in order to ascertain its type. */
    getFrankenResult = (results) => results?.length > 0 && results?.reduce((acc, currObj) => ({ ...acc, ...currObj }));
    
    shouldSetFrankenResult = (prevState, frankenResult) => {
        if (typeof prevState?.frankenResult === "undefined" && typeof frankenResult === "undefined") {
            return false;
        }
        if (typeof prevState?.frankenResult === "undefined") return true;
        const prevFrankenKeys = Object.keys(prevState.frankenResult);
        const frankenKeys = Object.keys(frankenResult);
        return !frankenKeys.every((key) => prevFrankenKeys.includes(key));
    };
    
    applySearchFilterFromEvent(event) {
        const newFilter = {
            ...JSON.parse(this.state.temp_filter),
            search_string: event.target.value
        };
        
        if (newFilter.search_string === "") {
            delete newFilter.search_string;
        }
    
        this.setFilter(JSON.stringify(newFilter));
    }
    
    applyFilter() {
        // Check if the filter is valid
        try {
            JSON.parse(this.state.temp_filter || "{}");
        } catch {
            toast.error("Unable to parse JSON");
            return;
        }

        this.setState((prevState, props) => {
            if (this.props.isMainReport) {
                updateURL({
                    filter: prevState.temp_filter,
                    filterBar: prevState.qualifiers,
                    page: 1,
                    walk: prevState.walk,
                    itemId: prevState.itemId,
                    id: props.id
                });
            }
            return { filter: prevState.temp_filter, page: 1 };
        }, this.fetchData());
    }

    fetchData() {
        // When a report is created in a dialog,
        // we prefetch data from a different endpoint.
        if (["grid_action", "combo_action"].includes(this.props.parentSelectedAction?.format)) {
            this.handleFetchPromise(
                PREFETCH_ACTION_DIALOG({
                    id: this.props.id,
                    page: this.state.page,
                    parentReportId: this.props.parentId,
                    action: this.props.parentSelectedAction.action_key,
                    parentReportItemIds: this.props.parentSelectedRows,
                    queryParams: {
                        filters: this.state.filter,
                        filterBar: encodeURIComponent(this.state.qualifiers),
                        ...this.props.queryParams
                    }
                })
            );
        } else if (this.props.parentSelectedAction?.format === "form_action") {
            return;
        } else if (this.state.walk?.length && this.state.report) {
            // when drilling into a report we shouldn't refetch
            // but we still need to fetch the child reports.
        } else {
            this.handleFetchPromise(
                REPORT_FETCH({
                    id: this.props.id,
                    page: this.state.page,
                    queryParams: {
                        filters: this.state.filter,
                        filterBar: encodeURIComponent(this.state.qualifiers),
                        ...this.props.queryParams
                    }
                })
            );
        }
        Object.values(this.#fetchChildrenPromises).map((childPromise) => childPromise.cancel());
        this.#fetchChildrenPromises = {};
        if (this.state.itemId !== null && this.props.meta?.child_reports?.length) {
            this.setState({
                childReportLoaded: false,
                childReportLoading: true
            }, () => {
                this.props.meta.child_reports.forEach((canonicalName) => {
                    this.#fetchChildrenPromises[canonicalName] = REPORT_FETCH({
                        id: canonicalName,
                        queryParams: {
                            backref: this.state.itemId,
                            parent_report: this.props.id
                        }
                    }).then((data) => {
                        this.setState((prevState) => ({
                            childReportLoading: false,
                            childReportLoaded: true,
                            child_reports: this.getChildReportEntry(canonicalName, data, prevState.child_reports || {}),
                            loading: false
                        }));
                    }, (error) => {
                        this.setState({
                            childReportLoading: false,
                            childReportLoaded: true
                        });
                    });
                });
            });
        }
    }

    getTabContent(childReport, canonicalName) {
        if (childReport?.count === 0) {
            return <Empty description={<span>No results available.</span>}/>;
        }
        return (
            <ReportView
                key={`child_${canonicalName}`}
                report={childReport}
                id={canonicalName}
                queryParams={{
                    backref: this.state.itemId,
                    parent_report: this.props.id
                }}
                walk={[]}
                showDetails={false}
                canCreateNew={false}
                canExport
                showCheckbox
                isChildReport
            />
        );
    }
    
    renderChildReport() {
        if (!this.state.displayChildReport || this.state.itemId === "new") return null;

        return (
            <div className="child-report">
                <Tabs
                    destroyInactiveTabPane
                    type="card"
                    animated
                    activeKey={this.state.activeTab}
                    onChange={this.setActiveTab}
                    items={this.props.meta?.child_reports?.map((canonicalName) => {
                        const childReport = this.state.child_reports?.[canonicalName];
                        return {
                            label: <ReportStatistic name={this.props.findReport(canonicalName)?.admin_report_name} count={childReport?.count} />,
                            key: `${canonicalName}_tab`,
                            children: this.getTabContent(childReport, canonicalName)
                        };
                    })}
                />
                <Divider />
            </div>
        );
    }
    
    renderFormAction() {
        if (this.state.form_data) {
            return (
                <ReportFormRedux
                    key={this.props.id}
                    meta={this.state.meta}
                    fetchReportForm={() => {
                        if (typeof this.state.form_data !== "undefined") {
                            return Promise.resolve(this.state.form_data);
                        }
                    }}
                    formRef={this.props.formRef}
                    hideActions
                />
            );
        }
        
        return null;
    }

    renderSingleItem() {
        if (this.props.meta?.is_editable) {
            if (!this.props.meta?.schema) {
                return (
                    <ErrorView
                        error={new ErrorMissingReportSchema({
                            custom: true,
                            // eslint-disable-next-line sentence-case/sentence-case
                            header: "Missing JSONSchema",
                            message: "Check your report configuration",
                            actions: false
                        })}
                    />
                );
            }

            return (
                <div>
                    {this.renderChildReport()}
                    <ReportFormRedux
                        key={`${this.props.id}_${this.state.itemId}`}
                        id={this.props.id}
                        itemId={this.state.itemId}
                        meta={this.props.meta}
                        fetchReportForm={this.fetchReportForm}
                        handleCancelForm={this.handleCancelForm}
                        handleSubmitForm={this.handleSubmitForm}
                    />
                </div>

            );
        }

        const item = this.state.report?.results.find(({ _id }) => _id === this.state.itemId);
        if (!item) {
            return (
                <ErrorView
                    error={new ErrorMissingRequestedItem({
                        custom: true,
                        message: "Cannot find requested item id",
                        hideDetails: true
                    })}
                />
            );
        }

        // Convert the item to key - value table
        const data = {
            results: Object.entries(item).map(([key, value]) => ({
                property: key,
                value
            }))
        };
        const frankenResult = this.getFrankenResult(data?.results);
        this.setState((prevState) => {
            if (this.shouldSetFrankenResult(prevState, frankenResult)) {
                return { frankenResult };
            }
        });

        return this.props.meta && (
            <div>
                {this.renderChildReport()}
                <ReportGrid
                    key={this.state.itemId}
                    data={data}
                    ref={this.reportGridRef}
                    fullReport={false}
                    single
                    numSelectedRows={this.state.selectedRows.length}
                    frankenResult={frankenResult}
                    {...this.getGenericReportGridProps()}
                />
            </div>
        );
    }

    renderPropertyOnItem() {
        let results;
        if (this.state.itemId) {
            const item = this.state.report?.results.find(({ _id }) => _id === this.state.itemId);
            if (!item) {
                return (
                    <ErrorView
                        error={new ErrorMissingRequestedItem({
                            custom: true,
                            message: "Cannot find requested item id",
                            hideDetails: true
                        })}
                    />
                );
            }

            results = get(item, this.state.walk.join("."));
        } else {
            results = get(this.state.report?.results, this.state.walk.join("."));
        }

        // `results` should always be an array of objects
        if (typeof results === "undefined") {
            results = [];
        } else if (results.length && !isPlainObject(results[0])) {
            results = results.map((result) => ({
                [this.state.walk[this.state.walk.length - 1]]: result
            }));
        } else if (isPlainObject(results)) {
            results = Object.entries(results).map(([key, value]) => ({
                property: key,
                value
            }));
        }
        const frankenResult = this.getFrankenResult(results);
        this.setState((prevState) => {
            if (this.shouldSetFrankenResult(prevState, frankenResult)) {
                return { frankenResult };
            }
        });

        return this.props.meta && (
            <ReportGrid
                key={this.state.walk.join(".")}
                data={{ results }}
                fullReport={false}
                walk={this.state.walk}
                frankenResult={frankenResult}
                {...this.getGenericReportGridProps()}
            />
        );
    }

    renderFullReport() {
        const frankenResult = this.getFrankenResult(this.state.report?.results);
        this.setState((prevState) => {
            if (this.shouldSetFrankenResult(prevState, frankenResult)) {
                return { frankenResult };
            }
        });
        return this.props.meta && (
            <ReportGrid
                key={this.props.id}
                data={this.state.report}
                ref={this.reportGridRef}
                fullReport
                hidePager={false}
                hasDetails={this.props.showDetails}
                hasRadio={this.props.hasRadio}
                hasCheckbox={this.props.hasCheckbox}
                selectRow={this.state.lastItemId}
                numSelectedRows={this.state.selectedRows.length}
                isMainReport={this.props.isMainReport}
                frankenResult={frankenResult}
                {...this.getGenericReportGridProps()}
                {...this.getCacheFunctions()}
            />
        );
    }

    renderBody() {
        if (this.state.walk.length) {
            return this.renderPropertyOnItem();
        }
        if (this.props.parentSelectedAction?.format === "combo_action") {
            return (
                <div>
                    {this.renderFullReport()}
                    {this.renderFormAction()}
                </div>
            );
        }
        if (this.props.parentSelectedAction === null || this.props.parentSelectedAction?.format === "form_action") {
            return this.renderFormAction();
        }
        if (this.state.itemId) {
            return this.renderSingleItem();
        }
        return this.renderFullReport();
    }

    render() {
        if (this.state.error?.hasError) {
            return (
                <ErrorView
                    error={new ErrorFetchingAdminReport({
                        message: "There was an error fetching this report",
                        hideDetails: true,
                        originalError: this.state.error,
                        tags: {
                            status: this.state.error?.status,
                            statusText: this.state.error?.statusText
                        }
                    })}
                />
            );
        }

        return (
            <div>
                <ReportHeader
                    id={this.props.id}
                    itemId={this.state.itemId}
                    globalItemId={this.props.globalItemId}
                    walk={this.state.walk}
                    isLoading={this.props.isLoadingAll}
                    count={this.state.report?.count}
                    canCreateNew={!this.state.itemId && this.props.canCreateNew && this.props.meta?.is_editable}
                    canExport={!this.state.itemId && this.props.canExport}
                    assignItemsSize={this.state.selectedRows.length}
                    getColumnNames={this.getColumnNames}
                    childReports={this.state.child_reports || null}
                    reportName={this.props.meta?.admin_report_name}
                    itemName={this.state.itemId && this.state.report?.results?.find(({ _id }) => _id === this.state.itemId)?.Title}
                    exportHandler={this.exportHandler}
                    createNewHandler={this.createNewHandler}
                    showAssignedItemsHandler={this.showAssignedItemsHandler}
                    displayChildReport={this.state.displayChildReport}
                    report_action_configs={this.props.meta?.report_action_configs}
                    onActionSelectedHandler={this.onActionSelectedHandler}
                    selectedAction={this.state.selectedAction}
                    onClearFilter={this.onClearFilter}
                    onRefreshFilter={this.onRefreshFilter}
                    onApplyFilter={this.onApplyFilter}
                    onKeyPressSearch={this.onKeyPressSearch}
                    onSearchChange={this.onSearchChange}
                    onFilterChange={this.onFilterChange}
                    filter={this.state.filter}
                    temp_filter={this.state.temp_filter}
                    isSearchable={this.props.meta?.is_searchable}
                    handleBreadcrumb={this.handleCancelForm}
                    filter_sources={this.props.meta?.filter_sources}
                    qualifiers={this.state.qualifiers}
                    onFilterBarUpdate={this.onFilterBarUpdate}
                    parentSelectedAction={this.props.parentSelectedAction}
                    grid_display_overrides={this.props.meta?.grid_display_overrides}
                />
                {this.renderBody()}
                <ActionDialog
                    show={this.state.showActionsModal}
                    action={this.state.selectedAction}
                    actionReport={this.props.findReport && this.props.findReport(this.state.selectedAction?.admin_report_ref)}
                    childReportId={this.props.id}
                    parentReportId={this.props.meta?.parentReportId}
                    handleAction={({ formData, action, selectedRows = [] }) => this.handleAction({
                        childReportId: this.props.id,
                        parentReportId: action.admin_report_ref,
                        parentReportItemId: selectedRows,
                        selectedChildItemIdList: this.state.selectedRows,
                        actionKey: action.action_key,
                        filter: this.state.filter,
                        formData
                    })}
                    createNew={() => {
                        this.setState({
                            displayChildReport: false
                        });
    
                        // Take selectedRows and create a new item under parentReportId
                        this.props.REPORT_NEW_ITEM_WITH_CHILDREN({
                            selectedRows: this.state.selectedRows,
                            parentReportId: this.props.meta?.parentReportId
                        });
                    }}
                    parentSelectedRows={this.state.selectedRows}
                    ReportView={ReportView}
                    hideModal={() => this.setState({ showActionsModal: false, selectedAction: null })}
                />
            </div>
        );
    }
}

const mergeProps = null;
const options = {
    forwardRef: true
};

export const ReportView = connect(mapStateToProps, mapDispatchToProps, mergeProps, options)(ReportViewRedux);

ReportView.defaultProps = {
    showCheckbox: true,
    showRadio: false,
    showDetails: true,
    canCreateNew: true,
    canExport: true,
    isChildReport: false
};
